import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { EventProperties } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { LeadDetails } from '@utils/backend-api/users';

import FooterContent from './FooterContent';

export interface FooterProps {
  analytics?: EventProperties;
  currentUserLoggedin: boolean;
  env: Env;
  isContentPage: boolean;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isPro: boolean;
  isSubscriber: boolean;
  isWebview: boolean;
  leadDetails: LeadDetails;
  subscribePathWithPossibleOffer: string;
}

const queryClient = new QueryClient();

const Footer = (props: FooterProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <FooterContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Footer;
